<template>
    <div class="toggle">
        <input type="hidden" :name="name" :value="falseValue">
        <label class="toggle-container">
            <input type="checkbox" :value="trueValue" :name="name" :checked="isChecked" @change="onChange">
			<span></span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        value: false,
        onChangeUrl: String,
        modelValue: {},
        trueValue: {
            type: String,
            default: '1'
        },
        falseValue: {
            type: String,
            default: '0'
        }
    },
    methods: {
        onChange(event) {
            let trueValue = this.trueValue ?? 1;
            let falseValue = this.falseValue ?? 0;
            let value = event.target.checked ? trueValue : falseValue;

            if (this.onChangeUrl) {
                let data = {};
                data[this.name] = value;
                axios.post(this.onChangeUrl, data);
            }
            this.$emit('change', event, value);
            this.$emit('update:modelValue', value);
        }
    },
    computed: {
        currentValue() {
            return this.modelValue ?? this.value;
        },
        isChecked() {
            let trueValue = this.trueValue ?? 1;
            return this.currentValue == trueValue;
        },
    }
}
</script>
